// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Resources
import FlagAU from "../../../image/flags/AU.png";
import FlagCA from "../../../image/flags/Canada.png";
import FlagCH from "../../../image/flags/CH.png";
import FlagGB from "../../../image/flags/GB.png";
import FlagMX from "../../../image/flags/MX.png";
import FlagNZ from "../../../image/flags/NZ.png";
import FlagUS from "../../../image/flags/US.png";

export default class AppInfo extends React.Component {
    ConvertToPriceString(currency, price) {
        if (price == null || price == undefined) return "-";
        try { if (parseInt(price) <= 0) return "Free"; }
        catch(ex) { }

        if (currency) return currency + " " + price;
        return price;
    }

    render() {
        return (
            <StyleWrapper className="app-header">
                <div className="app-info">
                    <div className="app-icon-container">
                        <img src={this.props.imgUrl} />
                    </div>

                    <div className="app-description">
                        <div className="app-name">{this.props.appName}</div>

                        <div className="app-stores">
                            Apple App Store:
                            <div className="stores">
                                <img src={FlagAU}/>
                                <img src={FlagCA}/>
                                <img src={FlagCH}/>
                                <img src={FlagGB}/>
                                <img src={FlagMX}/>
                                <img src={FlagNZ}/>
                                <img src={FlagUS}/>
                            </div>
                        </div>
                    </div>
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/AppInfo/index.js